// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { PlasmicWebHomepage3 } from "./plasmic/o_21_p_0_0_2_prod/PlasmicWebHomepage3";
import { Helmet } from "react-helmet-async";

function WebHomepage3_(props, ref) {
  return (
          <>
            <Helmet>
              
            </Helmet>
      
            <PlasmicWebHomepage3 root={{ ref }} {...props} />
          </>
        );
}

const WebHomepage3 = React.forwardRef(WebHomepage3_);

export default WebHomepage3;
